const validateColo=(formData)=>//check NG12 criteria
{


const refer = "NICE recommends an RDC referral"

const consider = "Nice recommends considering RDC referral if appropriate"

const fitRecommendedMessage="The patient does not meet the NICE criteria for Two week rule colorectal referral but on the basis of their symtoms, FIT testing is recommended.  If the patient has not already had recent negative FIT tests conider arranging these and making a colorectal 2wr referral if either of the FIT tests are positive. "

const idaMessage="Consider referral on an urgent IDA pathway."

const fitNegativeBleedingMessage = "Consider referral on the FIT -ve rectal bleeding pathway."

const safetyNetMessage = "If there is still a high level of concern regarding cancer, consider referral on an alternative pathway. Otherwise consider safety netting in the community"

let message =""

if (formData.fit)
    {
    formData.twrValid.colorectal=true
    message += refer
    }

else if(formData.rectalMass)

    {
    formData.twrValid.colorectal=true
    message += consider
    }
//checks criteria for recommendng FIT test
else if(
    formData.abdoMass
    ||formData.cobh 
    || formData.idAnaemia
    ||(formData.age>=40 && (formData.abdoPain && formData.weightLoss)) 
    ||(formData.rectalBleeding && (formData.abdoPain || formData.weightLoss))
    ||(formData.age>=50 && (formData.rectalBleeding || formData.abdoPain || formData.weightLoss))
    ||(formData.age >= 60 && formData.anaemia)
    )
        {
        message += fitRecommendedMessage
        formData.investigations.push("FIT tests")

        if (formData.idAnaemia)
            {
            message += idaMessage
            }
        else if (formData.rectalBleeding)
            {
            message += fitNegativeBleedingMessage
            }
        else 
            {
            message += safetyNetMessage
            }
        }


formData.message.colorectal = message

return formData
}

export default validateColo